import parseUrl from './parseUrl';

const WHATSAPP_HOSTNAMES = ['wa.me', 'api.whatsapp.com'];

export default function isWhatsappLink(url: string) {
  try {
    return WHATSAPP_HOSTNAMES.includes(parseUrl(url).hostname);
  } catch {
    return false;
  }
}
